import { useTranslation } from "react-i18next"

type Translations = typeof defaultTranslations

type UseTranslationsParams = {
  emailChangeRequestNewEmail?: string
  countdown?: string
}

const defaultTranslations = {
  email: "Email",
  updateEmail: "Change email",
  updateEmailDialogText:
    "Enter your new email address below and a verification code will be sent to this address. Your email will be changed after you verify the code.",
  cancel: "Cancel",
  sendCode: "Send code",
  deleteLabel: "Delete",
  emailChangeRequestHeader: "You have requested to change your email address.",
  emailChangeRequestText:
    "A verification code has been sent to {{emailChangeRequestNewEmail}}. Please check your inbox and enter the code below.",
  enterVerificationCode: "Enter verification code",
  verify: "Verify",
  verified: "Verified",
  codeExpiredText: "Your verification code has expired. Please request a new one.",
  codeCountdownText: "Your verification code will expire in {{countdown}}.",
}

export const useTranslations = ({
  emailChangeRequestNewEmail = "",
  countdown = "",
}: UseTranslationsParams = {}): Translations => {
  const { t } = useTranslation()

  return {
    email: t("email", { defaultValue: defaultTranslations.email }),
    updateEmail: t("updateEmail", { defaultValue: defaultTranslations.updateEmail }),
    updateEmailDialogText: t("updateEmailDialogText", {
      defaultValue: defaultTranslations.updateEmailDialogText,
    }),
    sendCode: t("sendCode", { defaultValue: defaultTranslations.sendCode }),
    cancel: t("cancel", { defaultValue: defaultTranslations.cancel }),
    deleteLabel: t("deleteLabel", { defaultValue: defaultTranslations.deleteLabel }),
    emailChangeRequestHeader: t("emailChangeRequestHeader", {
      defaultValue: defaultTranslations.emailChangeRequestHeader,
    }),
    emailChangeRequestText: t("emailChangeRequestText", {
      defaultValue: defaultTranslations.emailChangeRequestText,
      emailChangeRequestNewEmail,
    }),
    enterVerificationCode: t("enterVerificationCode", {
      defaultValue: defaultTranslations.enterVerificationCode,
    }),
    verify: t("verify", { defaultValue: defaultTranslations.verify }),
    verified: t("verified", { defaultValue: defaultTranslations.verified }),
    codeExpiredText: t("codeExpiredText", { defaultValue: defaultTranslations.codeExpiredText }),
    codeCountdownText: t("codeCountdownText", {
      defaultValue: defaultTranslations.codeCountdownText,
      countdown,
    }),
  }
}
